// 首页 CMS 区块
import { getPortalHome } from '@/api/portal'
import { normalizeHomeSections } from '@/components/home/utils/homeSectionNormalize'
import { HOME_PATH } from '@/components/layout/utils/navMenu'
import { isLocaleHomePath } from '@/components/portal/common/utils/localePath'

let homeFetchSeq = 0
let inflightHomeFetch = null

export default {
  namespaced: true,
  state: {
    sections: [],
    loading: false,
    loaded: false,
    locale: '',
    error: ''
  },
  getters: {
    enabledSections(state) {
      return state.sections
    },
    hasSections(state) {
      return state.sections.length > 0
    }
  },
  mutations: {
    SET_SECTIONS(state, sections) {
      state.sections = sections || []
      state.loaded = true
      state.error = ''
    },
    SET_LOADING(state, loading) {
      state.loading = loading
    },
    SET_LOCALE(state, locale) {
      state.locale = locale || ''
    },
    SET_ERROR(state, error) {
      state.error = error || ''
    },
    RESET(state) {
      state.sections = []
      state.loaded = false
      state.locale = ''
      state.error = ''
    }
  },
  actions: {
    // 回首页/点 Logo：按需确保首页相关数据（同语言已加载则跳过）
    async reloadContent({ dispatch }) {
      await dispatch('nav/ensureRawMenus', null, { root: true })
      await Promise.all([
        dispatch('footer/fetchFooter', null, { root: true }),
        dispatch('hero/fetchHero', null, { root: true }),
        dispatch('fetchHomeSections'),
        dispatch('solutions/fetchSolutions', null, { root: true }),
        dispatch('about/fetchAbouts', null, { root: true })
      ])
    },
    reloadByPath({ dispatch }, path) {
      if (path && !isLocaleHomePath(path) && path !== HOME_PATH) return Promise.resolve()
      return dispatch('reloadContent')
    },
    async fetchHomeSections({ commit, dispatch, state, rootState }, options) {
      const { force = false } = options ?? {}
      const locale = rootState.locale.current
      if (!locale) return []

      if (!force && state.loaded && state.locale === locale) {
        return state.sections
      }

      if (force) {
        homeFetchSeq += 1
        inflightHomeFetch = null
      }

      if (inflightHomeFetch?.locale === locale && !force) {
        return inflightHomeFetch.promise
      }

      const seq = ++homeFetchSeq
      // task
      const task = (async () => {
        commit('SET_LOADING', true)
        commit('SET_ERROR', '')
        try {
          const [data, menus] = await Promise.all([
            getPortalHome(locale, { reload: force }),
            dispatch('nav/ensureRawMenus', null, { root: true })
          ])
          if (seq !== homeFetchSeq) return []

          const sections = normalizeHomeSections(data, menus, locale)
          commit('SET_SECTIONS', sections)
          commit('SET_LOCALE', locale)
          return sections
        } catch (error) {
          if (seq !== homeFetchSeq) return []
          commit('SET_SECTIONS', [])
          commit('SET_ERROR', error?.message || '加载失败')
          throw error
        } finally {
          if (seq === homeFetchSeq) {
            commit('SET_LOADING', false)
          }
        }
      })()

      inflightHomeFetch = { locale, promise: task }
      try {
        return await task
      } finally {
        if (inflightHomeFetch?.promise === task) {
          inflightHomeFetch = null
        }
      }
    }
  }
}
